module.exports = __webpack_public_path__ + "static/media/result_fg_ja.72f7a4e5.jpg";